import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { setContentManagerSearchFilterType, setContentManagerSearchValue } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_ClearSearch(selectedItems: any[], waitFor: boolean) {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);

  const [menuItem_ClearSearch, setMenuItem_ClearSearch] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    if (searchValue) {
      setMenuItem_ClearSearch(
        {
          key: "clearSearch",
          text: `${languageStrings.ClearSearch}`,
          disabled: waitFor === true,
          iconProps: { iconName: "ClearFilter" },
          onClick: () => {
            dispatch(setContentManagerSearchValue(""));
            dispatch(setContentManagerSearchFilterType(""));
          }
        }
      )
    } else {
      setMenuItem_ClearSearch(null);
    }
  }, [selectedItems, waitFor, searchValue]);

  return {
    menuItem_ClearSearch
  }
}